import { Card } from 'antd';
import { SalesTable } from '../../components/Sales/SalesTable';
import { TitleBreadcrumbs } from '../../uiComponents/TitleBreadcrumbs';

export const OnlineSales = () => {
  return (
    <Card title={<TitleBreadcrumbs />} bordered={true} className="gx-card">
      <SalesTable saleType="online" />
    </Card>
  );
};
